import * as yup from 'yup';

export const gatewaySyncSchema = yup.object().shape({
  gateway: yup.string().required('Este campo é obrigatório.'),
});
